import * as angular from "angular";
import {IController} from "angular";

export class ProgramSkillsViewComponent implements IController {
  program: any;
  groups: any;
  programId: any;
  accountId: any;

  public isDesktop: boolean;
  public isSaveAvailable: boolean;
  public groupKeys: any;
  public groupKeysCopy: any;

  constructor(private PricePlanService, private $mdMedia) {
    this.isDesktop = $mdMedia('gt-md');
  }

  $onInit() {
    this.setGroupKeys();
  }

  onChange(selected: boolean, skillKey: string) {
    this.groupKeys.Skills[skillKey].selected = !selected ? null : selected;
    this.isSaveAvailable = true;
  }

  onSaveProgram() {
    const updatedProgram = this.PricePlanService.generatePreferencesDataPayload(this.program, this.groupKeys);
    this.PricePlanService.saveProgramDataByGroups(this.programId, updatedProgram, this.groups, this.accountId)
      .then((updatedProgram) => {
        this.program = updatedProgram;
      })
      .catch(() => {

      })
      .finally(() => {
        this.setGroupKeys();
      })
  }

  onCancelChanges(){
    this.groupKeys = angular.copy(this.groupKeysCopy);
    this.isSaveAvailable = false;
  }

  private setGroupKeys() {
    this.isSaveAvailable = false;
    this.groupKeys = this.PricePlanService.generatePreferencesDataGroupKeys(this.program.data);
    this.groupKeysCopy = angular.copy(this.groupKeys);
  }

}

angular
  .module('bringoz.admin.pricePlan')
  .component('programSkillsView', {
    bindings: {
      program: '<',
      groups: '<',
      programId: '<',
      accountId: '<?'
    },
    template: require('./program-skills-view.html').default,
    controller: ProgramSkillsViewComponent
  });
